import reducerRegistry from '@comeon/reducer-registry';
import { setShowAppBannerCookie } from '~/store/cookies';
import { syncCookies } from '~/store/ducks/cookies';

const REDUCER_NAME = 'appBanner';

const selectAppBanner = state => state[REDUCER_NAME];

export const APP_BANNER_SET_ENABLED = '@komigen/mobile-frontend/app-banner/APP_BANNER_SET_ENABLED';

export function setAppBannerEnabled(enabled) {
	setShowAppBannerCookie(enabled);

	return dispatch => {
		dispatch(syncCookies());
		return dispatch({
			type: APP_BANNER_SET_ENABLED,
			payload: {
				enabled
			}
		});
	};
}

function reducer(state = {}, { type, payload }) {
	if (type === APP_BANNER_SET_ENABLED) {
		return {
			...state,
			...payload
		};
	}
	return state;
}

reducerRegistry.register(REDUCER_NAME, reducer);

export { selectAppBanner };

export default reducer;
